import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as source from '../source'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: source.RESOURCE.payload.dimension.partialId,
      partialId: source.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'External system identifier (e.g. Jira, GitHub, etc.)',
    isOptional: false,
    name: 'System',
    partialId: PartialId.Standard.create('system'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
